/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".gallery-item[_ngcontent-%COMP%]{width:100%;max-width:100%;height:320px;margin:10px 0;cursor:pointer;overflow:hidden}@media only screen and (min-width:600px){.gallery-item[_ngcontent-%COMP%]{width:100%;height:720px}}.gallery-item[_ngcontent-%COMP%]   .image[_ngcontent-%COMP%]{max-height:100%;width:auto}.gallery-item[_ngcontent-%COMP%]   .video[_ngcontent-%COMP%]{height:100%;width:100%}h2[_ngcontent-%COMP%]{text-align:center;margin-top:20px;margin-bottom:10px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/downtown-life/construction.component.scss.shim.ngstyle.js.pre-build-optimizer.js